import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { trackPageView, setAnalyticsRole } from "../utils/analytics";

// Common Module
import Login from "../modules/common/pages/Login";
import Logout from "../modules/common/pages/Logout";

// Role-Based Routing
import RoleBasedRoute from "./RoleBasedRoute";

// Module Routes
import AdminRoutes from "../modules/admin/routes/AdminRoutes";
import MemberRoutes from "../modules/member/routes/MemberRoutes";

// Import Dashboard Pages
import AdminDashboard from "../modules/admin/pages/Dashboard";

// GA page view per route change; analytics.js sends the route pattern only.
// Role is re-read each time since it's set in localStorage at login.
function RouteTracker() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    setAnalyticsRole(localStorage.getItem("userRole"));
    trackPageView(pathname);
  }, [pathname]);
  return null;
}

export default function Index() {
  return (
    <Router>
      <RouteTracker />
      <Routes>
        {/* Common Routes */}
        <Route path="/" element={<Login />} />
        <Route path="/logout" element={<Logout />} />

        {/* Dashboard - Role-Based Rendering */}
        <Route
          path="/dashboard"
          element={
            <RoleBasedRoute
              adminComponent={<AdminDashboard />}
            />
          }
        />

        {/* Admin Routes - Admin-only pages */}
        <Route path="/members" element={<AdminRoutes />} />
        <Route path="/practitioner" element={<AdminRoutes />} />
        <Route path="/appointments" element={<AdminRoutes />} />
        <Route path="/calender" element={<AdminRoutes />} />
        <Route path="/settings" element={<AdminRoutes />} />
        <Route path="/support" element={<AdminRoutes />} />
        <Route path="/profile" element={<AdminRoutes />} />
        <Route path="/bulk-student" element={<AdminRoutes />} />
        <Route path="/add-member" element={<AdminRoutes />} />
        <Route path="/add-practitioner" element={<AdminRoutes />} />
        <Route path="/member-detail/:clientId" element={<AdminRoutes />} />
        <Route path="/practitioner-detail/:counsellorId" element={<AdminRoutes />} />
        <Route path="/appointment-detail/:appointmentId" element={<AdminRoutes />} />
        <Route path="/member-summary-report/:appointmentId" element={<AdminRoutes />} />
        <Route path="/schedule-wellness" element={<AdminRoutes />} />
        <Route path="/schedule-health-camp" element={<AdminRoutes />} />
        <Route path="/run-survey" element={<AdminRoutes />} />
        <Route path="/user-risk" element={<AdminRoutes />} />
        <Route path="/counsellor-managment" element={<AdminRoutes />} />
        <Route path="/add-counsellor" element={<AdminRoutes />} />
        <Route path="/kyc-users" element={<AdminRoutes />} />

        {/* Member Routes - All member/client routes with /member prefix */}
        <Route path="/member/*" element={<MemberRoutes />} />

        {/* Fallback - Redirect to dashboard if logged in, otherwise to login */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}
